import { TimeRange } from '@nirvana/shared/dtos/types/shared/time';
import { Dashboard, Position, Status, Target, WidgetType, WidgetWithId } from './shared-dtos-dashboards-common';

// Object used to insert a new widget or update an existing widget.
// TODO(fburuiana): Check how to reuse this with Widget.
export interface Widget {
  type: WidgetType;
  pos?: Position;
  width: number;
  height: number;
}

export interface InitDashboardsRequest {}

export interface InitDashboardsResponse {
  status: Status;
  dashboards?: Dashboard[];
  targets: Array<Target>;
  isPartner: boolean;
  hasReportsEnabled: boolean;
}

export enum AvailableCompaniesSource {
  FROM_EDR = 'fromEdr',
  FROM_LIVESEARCH = 'fromLiveSearch',
  FROM_ASM = 'fromASM',
  FROM_CONFIGURATION_PROFILES = 'fromConfigurationProfiles',
  FROM_EXCHANGE = 'fromExchange',
}

export interface GetAvailableCompaniesOptions {
  source?: AvailableCompaniesSource;
  countRecords?: boolean;
}

export interface GetAvailableCompaniesParams {
  user?: string;
  includeOwnCompany?: boolean;
  includeTargetCompanies?: boolean;
  includeOwnCompanyIfInTargets?: boolean;
  includeOwnCompanyIfInTargetsOnlyOwnCompany?: boolean;
  includeOnlyWithFullAccess?: boolean;
  includeOnlyWithNetworkAccess?: boolean;
  includeOnlyWithCompaniesAccess?: boolean;
  includeOnlyManagedBy?: number;
  includeOwnCompanyIfInTargetsOnlyNetwork?: boolean;
  includeOwnCompanyWithAnyNetworkAccess?: boolean;
  includeOnlyCompaniesFromFilters?: boolean;
  source?: AvailableCompaniesSource;
  companyIds?: Array<string>;
  getOnlyChildrenOfNodes?: Array<string>;
  // Do not abuse this parameter, make sure you do send a sensible limit manually
  ignoreLimit?: boolean;
  selectedFields?: Array<string>;
  excludeCompanion?: boolean;
  countRecords?: boolean;
  options?: GetAvailableCompaniesOptions;
}

export interface GetCompaniesRequest {
  companyName?: string;
  params?: GetAvailableCompaniesParams;
}

export interface GetCompaniesResponse {
  targets: Array<Target>;
}

export interface SetTimeRangeRequest {
  dashboardId: string;
  timeRange: TimeRange;
}

export interface SetTargetsRequest {
  dashboardId: string;
  targets: Array<string>;
}

export interface SetTimeRangeResponse {}

export interface SetTargetsResponse {}

export interface CreateDashboardRequest {
  name: string;
  widgets?: Widget[];
}

export interface CreateDashboardResponse {
  dashboardId: string;
}

export interface DeleteDashboardRequest {
  dashboardId: string;
}

export interface DeleteDashboardResponse {}

export interface GetWidgetsForDashboardRequest {
  dashboardId: string;
}

export interface GetWidgetsForDashboardResponse {
  widgets: WidgetWithId[];
  canDrillDown?: boolean;
}

export interface AddWidgetToDashboardRequest {
  dashboardId: string;
  widget: Widget;
}

export interface AddWidgetToDashboardResponse {
  widgetId: string;
}

export interface DeleteWidgetFromDashboardRequest {
  dashboardId: string;
  widgetId: string;
}

export interface DeleteWidgetFromDashboardResponse {}

export interface EditWidgetsFromDashboardRequest {
  dashboardId: string;
  widgets?: WidgetWithId[];
}

export interface EditWidgetsFromDashboardResponse {}
